import React from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import ContactBtns from '../../consumer-new-footer/components/ContactBtns';

const DSRSuccess = () => (
  <div className="dsr-section">
    <h1>
      <IconMaterialsDesigned
        color="#6bb7bf"
        className="w-11 h-auto mr-3.5 relative top-1"
      />
      Your request has been successfully sent.
    </h1>
    <h3 className="max-md:mt-2 max-md:mx-0 max-md:mb-3">
      We will contact you in the next 45 days with next steps.
    </h3>
    <div className="text-base">
      If you have any questions or concerns, please contact us directly.
      We&apos;re available by phone (888.282.0842) M-F 5:30am - 6pm PST, and S-S
      7:30am PST.
    </div>
    <ContactBtns variant="dsr" />
    <div className="text-base">
      In the meantime,&nbsp;
      <CtaLink
        to="/customer-photos/"
        color="brand"
        hasArrow={false}
        noLinkPadding
      >
        start getting inspired
      </CtaLink>
      &nbsp;for your next project!
    </div>
  </div>
);

export default DSRSuccess;
